module.exports = __webpack_public_path__ + "static/media/15.6f314ab1.jpg";